import { ICollidable, Bounds } from './collision/types';
import { Cat } from './cat';

export class Collectable implements ICollidable {
	x: number;
	y: number;
	size: number;
	isCollected: boolean;
	readonly collisionType = 'collectable';

	constructor(x: number, y: number, size: number = 40) {
		this.x = x;
		this.y = y;
		this.size = size;
		this.isCollected = false;
	}

	draw(): void {
		if (this.isCollected) return;

		push();
		translate(this.x, this.y);

		const p = 2; // Pixel size

		noStroke();

		// Pixel art heart shape (8x7 pixels)
		// Row 0: outline top
		fill(0);
		rect(-3 * p, -3 * p, p, p);
		rect(-2 * p, -4 * p, p, p);
		rect(-1 * p, -4 * p, p, p);
		rect(0 * p, -3 * p, p, p);
		rect(1 * p, -4 * p, p, p);
		rect(2 * p, -4 * p, p, p);
		rect(3 * p, -3 * p, p, p);

		// Row 1: outline sides + red fill
		rect(-4 * p, -2 * p, p, p);
		rect(4 * p, -2 * p, p, p);
		fill(255, 0, 0);
		rect(-3 * p, -2 * p, 7 * p, p);

		// Row 2: outline sides + red fill
		fill(0);
		rect(-4 * p, -1 * p, p, p);
		rect(4 * p, -1 * p, p, p);
		fill(255, 0, 0);
		rect(-3 * p, -1 * p, 7 * p, p);

		// Row 3: narrowing
		fill(0);
		rect(-4 * p, 0 * p, p, p);
		rect(4 * p, 0 * p, p, p);
		fill(255, 0, 0);
		rect(-3 * p, 0 * p, 7 * p, p);

		// Row 4: narrowing more
		fill(0);
		rect(-3 * p, 1 * p, p, p);
		rect(3 * p, 1 * p, p, p);
		fill(255, 0, 0);
		rect(-2 * p, 1 * p, 5 * p, p);

		// Row 5: narrowing more
		fill(0);
		rect(-2 * p, 2 * p, p, p);
		rect(2 * p, 2 * p, p, p);
		fill(255, 0, 0);
		rect(-1 * p, 2 * p, 3 * p, p);

		// Row 6: bottom tip
		fill(0);
		rect(-1 * p, 3 * p, p, p);
		rect(1 * p, 3 * p, p, p);
		fill(255, 0, 0);
		rect(0 * p, 3 * p, p, p);

		// Row 7: bottom point
		fill(0);
		rect(0 * p, 4 * p, p, p);

		pop();
	}

	getBounds(): Bounds {
		return {
			x: this.x - this.size / 2,
			y: this.y - this.size / 2,
			width: this.size,
			height: this.size,
		};
	}

	isActive(): boolean {
		return !this.isCollected;
	}

	onCollision(other: ICollidable): void {
		// When an animal collides with this collectable, heal them and collect
		if (other instanceof Cat) {
			other.heal(1);
			this.collect();
		}
	}

	collect(): void {
		this.isCollected = true;
	}
}
